export default __webpack_public_path__ + "static/media/menu-up-icon.7ad49416.svg";